import { shiftService } from '_services';
import { session } from '_helpers';
import { ACTIONS_SHIFT } from '_constants/shift.constants';
import alertActions from './alert.actions';

export const receiveShifts = (shifts) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < shifts.length; i++) {
    byIdObjectToDispatch[shifts[i].shiftID] = shifts[i];
  }

  return {
    type: ACTIONS_SHIFT.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteShift = (shiftId) => ({
  type: ACTIONS_SHIFT.DELETE,
  byId: { [shiftId]: null }
});

const getShifts = (accountID) => async (dispatch) => {
  try {
    const resp = await shiftService.getAll(accountID);
    if (resp?.[0]?.shiftID) {
      dispatch(receiveShifts(resp));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error('Error retrieving shifts.', e));
  }
  return null;
};

const getShift = (shiftID) => async (dispatch) => {
  try {
    const resp = await shiftService.getById(shiftID);
    if (resp?.shiftID) {
      dispatch(receiveShifts([ resp ]));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error retrieving shift #${shiftID}.`, e));
  }
  return null;
};

const addShift = (shift) => async (dispatch) => {
  try {
    const resp = await shiftService.create(shift);
    if (resp?.shiftID) {
      dispatch(receiveShifts([ resp ]));
      return resp;
    }
  } catch (e) {
    session.checkSession(e);
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const updShift = (shift) => async (dispatch) => {
  try {
    const resp = await shiftService.update(shift);
    if (resp?.shiftID) {
      dispatch(receiveShifts([ resp ]));
      return resp;
    }
  } catch (e) {
    session.checkSession(e);
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const delShift = (shiftID) => async (dispatch) => {
  try {
    const resp = await shiftService.delete(shiftID);
    if (resp?.shiftID) {
      dispatch(deleteShift(resp.shiftID));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error removing shift #${shiftID}.`, e));
  }
  return null;
};

const shiftActions = {
  getShifts,
  getShift,
  addShift,
  updShift,
  delShift
};

export default shiftActions;
